export default "__VITE_ASSET__BKmmUfu0__"